import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  data: [],
  loading: false,
  error: null,
};
const statusreportSlice = createSlice({
  name: "statusreport",
  initialState,
  reducers: {
    fetchStatusReportRequest(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchStatusReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload.data;
    },
    fetchStatusReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});
export const {
  fetchStatusReportRequest,
  fetchStatusReportSuccess,
  fetchStatusReportFailure,
} = statusreportSlice.actions;
export default statusreportSlice.reducer;
